import { render, staticRenderFns } from "./fork_sync_conflicts_modal.vue?vue&type=template&id=530a33c8"
import script from "./fork_sync_conflicts_modal.vue?vue&type=script&lang=js"
export * from "./fork_sync_conflicts_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports